<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/menu/index' }">菜单管理</el-breadcrumb-item>
      <el-breadcrumb-item>菜单编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="formData" label-width="100px">
          <el-form-item label="菜单名称">
            <el-col :span="12">
              <el-input size="small" v-model="formData.menu_name" placeholder="请输入菜单名称"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="菜单URL">
            <el-col :span="12">
              <el-input size="small" v-model="formData.url" placeholder="请输入菜单URL"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="父级">
            <el-col :span="12">
              <el-select size="small" v-model="formData.parent_code" style="width: 100%">
                <el-option value="0" label="└顶级菜单"></el-option>
                <el-option
                  v-for="(item, index) in menuList"
                  :key="index"
                  :value="item.id"
                  :label="item.new_menu_name"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="图标">
            <el-col :span="12">
              <iconSelect :curricon="formData.icon" @activeIcon="activeIcon"></iconSelect>
            </el-col>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-col :span="12">
              <el-radio-group v-model="formData.is_show">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">不显示</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="排序">
            <el-col :span="12">
              <el-input size="small" v-model="formData.sort" placeholder="排序"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import iconSelect from "@/components/icon_select.vue";
export default {
  components: {
    iconSelect
  },
  data() {
    return {
      id: "",
      formData: {
        menu_name: "",
        url: "",
        parent_code: "0",
        icon: "",
        is_show: 0,
        sort: ""
      },
      menuList: []
    };
  },
  methods: {
    activeIcon(icon) {
      this.formData.icon = icon;
    },
    save() {
      let _formData = this.formData;
      _formData.id = this.id;
      if (_formData.menu_name == "" || _formData.url == "") {
        this.$util.msg("请完善信息");
      } else {
        this.$ajax({
          loading: true,
          type: "post",
          url: "/menu/update",
          data: _formData
        }).then(data => {
          this.$util.msg(data.msg, "success");
          setTimeout(() => {
            this.$router.push({ path: "/menu/index" });
          }, 1200);
        });
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.$ajax({
      url: "/menu/index"
    })
      .then(data => {
        let _data = data.data;
        _data.forEach(item => {
          if (item.level == 1) {
            item.new_menu_name = `└${item.menu_name}`;
          } else if (item.level == 2) {
            item.new_menu_name = `ㅤ└${item.menu_name}`;
          } else if (item.level == 3) {
            item.new_menu_name = `ㅤㅤ└${item.menu_name}`;
          }
        });
        this.menuList = _data;
      })
      .catch(err => {});
    this.$ajax({
      url: "/menu/one",
      data:{
        id: this.id
      }
    })
      .then(data => {
        let _data = data.data;
        this.formData.menu_name = _data.menu_name;
        this.formData.url = _data.url;
        this.formData.parent_code =
          _data.parent_code == "0" ? "0" : parseInt(_data.parent_code);
        this.formData.icon = _data.icon;
        this.formData.is_show = _data.is_show;
        this.formData.sort = _data.sort;
      });
  }
};
</script>
<style>
</style>